import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import SubmitButton from 'components/Submits/SubmitButton';

const styles = {
    lineHeight: 'normal',
    height: '100%',
    '&:not(:last-child)': {
        marginRight: '1rem',
    },
};

export const StyActionBarButton = styled(Button, {
    name: 'StyActionBarButton',
})(styles);

export const StyActionBarSubmitButton = styled(SubmitButton, {
    name: 'StyActionBarButton',
    shouldForwardProp: (prop) => prop !== 'isDestructive',
})<{ isDestructive?: boolean }>(({ isDestructive = false, theme }) => {
    const color = isDestructive
        ? theme.palette.red
        : theme.palette.primary.main;
    const hoverColor = isDestructive
        ? theme.palette.lightRed
        : theme.palette.primary.main;
    return {
        ...styles,
        ...(isDestructive ? { border: `1px solid ${theme.palette.red}` } : {}),
        color,
        alignSelf: 'flex-start',
        '&:hover': {
            border: `1px solid ${hoverColor}`,
        },
    };
});
